import React, { Component } from 'react'

import { action, makeObservable, observable } from 'mobx'
import { inject, observer } from 'mobx-react'

import RecurringWorkflowSettings from '~/client/src/shared/models/RecurringWorkflowSettings'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import PermitDatePicker from '../../../PermitDatePicker/PermitDatePicker'
import SitePermitCreationFormStore from '../../WorkflowCreationForm.store'

interface IProps {
  store: SitePermitCreationFormStore
  projectDateStore?: ProjectDateStore
}

@inject('projectDateStore')
@observer
export default class RecurringWorkflowOptionsDatePicker extends Component<IProps> {
  @observable private localProps: IProps = null

  public constructor(props: IProps) {
    super(props)
    this.localProps = props
    makeObservable(this)
  }

  public render() {
    const { isRecurringDatepickerShown, editableRecurringSettings } =
      this.localProps.store

    return (
      <>
        {isRecurringDatepickerShown && (
          <PermitDatePicker
            isOneDayMode
            shouldShowTimePicker={false}
            initialStartDate={editableRecurringSettings?.endDate}
            initialEndDate={editableRecurringSettings?.endDate}
            applyDates={this.applyDates}
            hideDatePicker={this.hideDatePicker}
            shouldDateBeDisabled={this.shouldDateBeDisabled}
          />
        )}
      </>
    )
  }

  @action.bound
  private applyDates(startDate: Date) {
    const { editableRecurringSettings } = this.localProps.store
    const settings =
      editableRecurringSettings.getCopy() as RecurringWorkflowSettings

    settings.endDate = startDate.getTime()
    this.localProps.store.setRecurringSettings(settings)
  }

  @action.bound
  private hideDatePicker() {
    this.localProps.store.isRecurringDatepickerShown = false
  }

  private shouldDateBeDisabled = (date: Date): boolean => {
    const {
      store: { maxRecurringDuration, editablePermit },
      projectDateStore: { startOfDay, addDays },
    } = this.localProps

    const startDate = startOfDay(editablePermit.startDate || new Date())

    const maxDate = addDays(startDate, maxRecurringDuration)

    return date > maxDate || date <= startDate
  }
}
